import { FunctionComponent, useCallback, useMemo } from "react";
import { SilkWrapper, TrapWrapper } from "@ppb/the-wall-web";
import { BetSelectionDetails } from "../BetSelectionDetails/BetSelectionDetails.web";
import { FallbackIconType } from "@ppb/the-wall-common/types";
import { RacingSport } from "../../constants";
import { ComponentProps } from "./props";

export const Selection: FunctionComponent<ComponentProps> = ({
  urn,
  id,
  title,
  subtitle,
  racingSport,
  trap,
  meetingCountry,
  icon,
  silkFallbackType,
  odd,
  oddsMovement,
  isReadOnly,
  isPlacing,
  is90Min,
  selectionTypeIcon,
  isTrapIconEnabled,
  dispatchSelectionRemove,
}) => {
  const onSelectionRemove = useCallback(
    () => urn && dispatchSelectionRemove(id, urn),
    [dispatchSelectionRemove, id, urn],
  );

  const IconComponent = useMemo(() => {
    if (racingSport === RacingSport.HORSE_RACING) {
      return <SilkWrapper silkUrl={icon} silkFallbackType={silkFallbackType as FallbackIconType} silkAlt={icon} />;
    }

    if (racingSport === RacingSport.GREYHOUND_RACING && trap && isTrapIconEnabled) {
      return <TrapWrapper region={meetingCountry ?? "AGNOSTIC"} trap={trap} size="small" />;
    }

    return undefined;
  }, [racingSport, trap, isTrapIconEnabled, icon, silkFallbackType, meetingCountry]);

  if (!urn) {
    return null;
  }

  return (
    <BetSelectionDetails
      key={id}
      title={title}
      subtitle={subtitle}
      icon={IconComponent}
      odd={odd}
      oddsMovement={oddsMovement}
      onSelectionRemove={isReadOnly ? undefined : onSelectionRemove}
      isPlacing={isPlacing}
      is90Min={is90Min}
      selectionTypeIcon={selectionTypeIcon}
    />
  );
};
